<template>
    <div class="main-content-container  container-fluid ">
        <div class="page-header">
            <!-- 
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
       
                <h4 class="text-uppercase"> Cotiza tu Seguro</h4>
            </div>
            -->
            <div class="text-center">               
                <h4 class="text-uppercase"> Cotiza tu Seguro Con</h4>
            </div>
            <div class="image-container">
                    <img class="centered-image" src="../assets/images/lasegunda.png">
            </div> 
            <div class="image-container">
                <br>
            </div>
            

        </div>


        <w-card size="100" title="Por favor complete los siguientes datos">
            <el-form 
                :model="segForm" 
                status-icon 
                :rules="rules"
                label-position="top"	 
                ref="segForm"
                class="demo-ruleForm" 
                >

                 <!--  <el-form-item label="1 - Ingrese el CUIT" prop="region">
                    <el-input 
                    v-model="userCuitFormatted" 
                    placeholder="Ingrese CUIT"
                    @input.native="handleInputCuit"
                    >
                    </el-input>
                </el-form-item>
                -->

                <el-form-item label="Condición fiscal" prop="region" class="bold-label">
                        <el-select v-model="segForm.fiscal" placeholder="Seleccionar" style="width: 70%">
                            <el-option v-for="(condicion,index) in condicionesFiscales" :key="index" :label=condicion :value=condicion></el-option>    
                    </el-select>
                </el-form-item>

                <el-form-item label="Ingrese su direccion" class="bold-label">
                    <el-input
                        placeholder=""
                        prefix-icon="el-icon-right"
                        v-model="segForm.address"
                        style="width: 70%;"
                        :maxlength="60"  
                        
                        >
                        <!--show-word-limit  Para mostrar la cantidad de caracteres restantes-->
                    </el-input>
                </el-form-item>

                <el-form-item label="Seleccione la moneda" class="bold-label">
                    <el-select v-model="segForm.moneda" placeholder="Seleccionar" style="width: 70%" @change="handleChangeMoneda">
                            <el-option v-for="(moneda,index) in monedas" :key="index" :label=moneda :value=moneda></el-option>    
                    </el-select>
                </el-form-item>
                <!-- 
                <el-form-item label="2 - Ingrese la suma asegurada en pesos">
                    <el-input
                        placeholder="Valor maximo $2740.000.000"
                        prefix-icon="el-icon-right"
                        v-model="segForm.sumaAsegurada"
                        style="width: 70%;"
                        @input.native="handleInput" 
                        >                
                    </el-input>
                </el-form-item>
                
                <el-form-item label="3 - Código postal donde se encuentran los silosbolsa">
                    <el-input
                        placeholder=""
                        prefix-icon="el-icon-right"
                        v-model="segForm.codigoPostal"
                        style="width: 70%;"
                        >
                    </el-input>
                </el-form-item>
                -->

                <el-form-item label="Seleccione el plan" class="bold-label">
                    <el-select v-model="segForm.plan" placeholder="Seleccionar" style="width: 70%">
                            <el-option v-for="(plan,index) in planes" :key="index" :label=plan :value=plan></el-option>    
                    </el-select>
                </el-form-item>

                <el-form-item label="Seleccione las cuotas" class="bold-label">
                    <el-select v-model="segForm.cuotas" placeholder="Seleccionar" style="width: 70%">
                            <el-option v-for="(cuota,index) in cuotas" :key="index" :label=cuota :value=cuota></el-option>    
                    </el-select>
                </el-form-item>
                <el-form-item label="Selecciona los silobolsas para asegurar" class="bold-label" > <!-- prop="silos"-->
                    <div class="accordionComponent">
                        <el-collapse v-model="activeName"  > <!--accordion-->
                            <el-collapse-item v-for="(establishment,index) in establishments" :key="index"  :name="index"  class="content" >
                                <template #title>
                                    <span class="estabitem" >Establecimiento: &nbsp;</span>  <span class='estabtitle'>{{ estabTitle(establishment.name) }}</span>
                                </template>

                                <el-checkbox-group  v-model="segForm.silos">  <!-- @change="handleCheckedChange"-->
                                    <div v-for="(silos) in establishment.silos" >
                                        <el-checkbox
                                            :label="getSiloLabel(establishment.id, silos.id)" 
                                            :key="`${establishment.id}_${silos.id}`" 
                                            class="checkbox-item">
                                            {{ showSiloInfo(silos) }}
                                        </el-checkbox>
                                        <div v-if="isSelected(establishment.id, silos.id)" >                                          
                                            <div>          
                                               <el-input                                                 
                                                    v-model="silosDetails[establishment.id][silos.id].postalCode" 
                                                    :disabled="silosDetails[establishment.id][silos.id].locationSearhing"
                                                    placeholder="Ingrese CP"
                                                    >    
                                                    <template #prepend>
                                                        <span class="demo-input-label">Código Postal (del silo)</span>                                                                       
                                                    </template>                                                
                                                </el-input>
                                            </div>                                          
                                            <div>
                                                <el-input 
                                                    v-model="silosDetails[establishment.id][silos.id].insuredAmount" 
                                                    :placeholder=sumaAseguradaPlaceholder()
                                                    :disabled="!checkSelectedMoneda() || silosDetails[establishment.id][silos.id].amountSearching"
                                                    @input.native="handleInput"
                                                    :maxlength="15"  
                                                    >
                                                    <template #prepend>
                                                        <span class="demo-input-label">
                                                            <span>Suma a Asegurar </span>
                                                            <span v-if="segForm.moneda == 'Pesos'">en $</span> 
                                                            <span v-else-if="segForm.moneda == 'Dolares'">en U$S</span>
                                                            <span v-else></span>
                                                        </span>
                                                    </template>
                                                    <template #append>
                                                        <el-tooltip :content="getTooltipText()" placement="left-start">
                                                            <i class="el-icon-question" style="cursor: pointer; margin-left: 8px;"></i>
                                                        </el-tooltip>
                                                    </template>
                                                </el-input>
                                            </div>  
                                           
                                            <hr style="width: 30%; margin-top: 15px; margin-bottom: 15px;">                      
                                           
                                        </div>
                                    </div>                                
                                </el-checkbox-group>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </el-form-item>
            </el-form>

            <div class="stats" v-if="isSiloSelected">
                <h4>Total a Cotizar</h4>
                <div v-for="(sum,index) in sumarized" :key="index" class="statscontent">
                    <el-row  class="rowcontent" :gutter="20">
                        <el-col :span="6">
                            <div>
                                <el-statistic title="Grano">
                                    <template slot="formatter">
                                        {{getGrainName(sum.type)}}
                                    </template>
                                </el-statistic>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div>
                                <el-statistic title="Total de Silos Bolsa">
                                    <template slot="formatter">
                                        {{sum.count}}
                                    </template>
                                </el-statistic>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div>
                                <el-statistic
                                    group-separator="."
                                    :precision="0"
                                    :value="sum.tons"
                                    :title="statTitle"
                                >
                                </el-statistic>
                            </div>
                        </el-col>
                    </el-row>
                    <br>
                    <hr style="width: 30%;">
                    <br>
                </div>
                <div v-if="checkSelectedMoneda()" class="statscontent">                   
                    <h4>Suma total a cotizar</h4>
                    <span class="moneda" v-if="segForm.moneda == 'Pesos'">$ </span> 
                    <span class ="moneda" v-else-if="segForm.moneda == 'Dolares'">U$S </span>
                    <span v-else></span>                   
                    <span class="monto">
                        {{ formatNumber(sumaAseguradaTotal) }}
                    </span> 
                    <hr style="width: 60%;">
                </div>
                <el-button @click="confirmBorrarSeleccion()" round type="danger">
                    Borrar Seleccion
                </el-button>
            </div>
            <div class="acction-button-container">
                <el-button type="primary" class="button button--shadow button--fixed-width" round 
                    @click="sendRequest()">
                        {{goMessage}}
                </el-button>
                <el-button type="plain" class="button button--fixed-width button--shadow" round @click="cancel()">
                    {{cancelMessage}}
                </el-button>
            </div>
        
        </w-card>

        <el-dialog class="dialog"  :visible.sync="dialogFormVisible" :fullscreen="isFullscreen">
                <template #title>
                    <!-- Botón de maximizar/restaurar -->
                    <el-button 
                        @click="toggleFullscreen"
                        icon="el-icon-full-screen" 
                        size="mini" 
                        circle
                        style="min-width: fit-content;"   
                    >
                    <!--style="margin-right: 10px;"-->
                    </el-button>
                    <h3>Por favor confirme los datos a enviar</h3>                   
                    <span  class="dialog-footer">
                        <hr style="width: 100%;">
                        <el-button @click="sendCancel()">Cancelar</el-button>
                        <el-button type="primary" @click="sendConfirm()">Confirmar</el-button>
                </span>
                </template>


                <!--<span slot="footer" class="dialog-footer">
                        <hr style="width: 100%;">
                        <el-button @click="sendCancel()">Cancelar</el-button>
                        <el-button type="primary" @click="sendConfirm()">Confirmar</el-button>
                </span>
                -->
                <div class="dialog-content" ref="dialogContent">
                   
                    <div  v-if="!hideClientData"  >
                        <h2 style="text-align: center;"> Pedido de cotizacion desde la plataforma de Wiagro</h2>
                        <h3>Datos del cliente</h3>
                        <el-table 
                            :data="userData"            
                            stripe
                            border
                        
                        >

                        <el-table-column property="item" label="" width="165">
                            <template slot-scope="scope">
                                <span class="item-bold">{{ scope.row.item }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column property="valor" label="" width="350">
                            <template slot-scope="scope">
                                <span v-if="isItemTotalAsegurado(scope.row.item)" class="valor-italic">
                                    {{ formatNumber(scope.row.valor) }}
                                    <span  v-if="segForm.moneda == 'Pesos'"> $</span> 
                                    <span  v-else-if="segForm.moneda == 'Dolares'"> U$S</span>
                                </span>
                                <span v-else class="valor-italic">{{ scope.row.valor }}</span>
                            </template>
                        </el-table-column>                    
                        </el-table>
                        <hr style="width: 100%;">
                   
                        <h3>Datos de los silos</h3>
                        <!--<el-table 
                            :data="siloData"            
                            stripe
                            border  
                            style="min-width: fit-content;  table-layout: auto;"                      
                        >                  
                        <el-table-column property="establecimiento" label="Establecimiento" :min-width="180" ></el-table-column>
                        <el-table-column property="silo" label="Silo" :min-width="160" ></el-table-column>
                        <el-table-column property="almac" label="Almacenamiento" :min-width="150" ></el-table-column>
                        <el-table-column property="tons" label="Toneladas" :min-width="95"></el-table-column>
                        <el-table-column property="moisture" label="Humedad" :min-width="90" ></el-table-column>                                            
                        
                        <el-table-column label="Estado" :min-width="100">
                            <template slot-scope="scope">
                                <span :class="getEstadoClass(scope.row.conservation)">
                                    {{ getEstadoText(scope.row.conservation) }}
                                </span>
                            </template>
                        </el-table-column>                         

                        <el-table-column property="insuredAmount" :min-width="150" label="Suma Asegurada" ></el-table-column>
                        <el-table-column property="moneda" label="Moneda" ></el-table-column>
                        <el-table-column property="cp" label="Codigo Postal" ></el-table-column>
                        <el-table-column property="provincia" label="Provincia" :min-width="150" ></el-table-column>
                        <el-table-column property="municipio" label="Municipio":min-width="250" ></el-table-column>
                        
                        <el-table-column label="Ubicacion" :min-width="450">
                            <template slot-scope="scope">
                                <a :href="scope.row.location" target="_blank">{{ scope.row.location }}</a>
                            </template>
                        </el-table-column>
                        </el-table>
                    -->

                        <el-table 
                            :data="siloData"            
                            stripe
                            border  
                            style="min-width: fit-content;  table-layout: auto;"                      
                        >   
          
                        <el-table-column property="establecimiento" label="Establecimiento" ></el-table-column>
                        <el-table-column property="silo" label="Silo"  ></el-table-column>
                        <el-table-column property="almac" label="Almacenamiento" ></el-table-column>
                        <el-table-column property="tons" label="Toneladas"></el-table-column>
                        <el-table-column property="moisture" label="Humedad" ></el-table-column>                                            
                        
                        <el-table-column label="Estado" >
                            <template slot-scope="scope">
                                <span :class="getEstadoClass(scope.row.conservation)">
                                    {{ getEstadoText(scope.row.conservation) }}
                                </span>
                            </template>
                        </el-table-column>                         

                        <el-table-column property="insuredAmount" label="Suma A Asegurar" ></el-table-column>
                        <!--<el-table-column property="moneda" label="Moneda" ></el-table-column>-->
                        <el-table-column property="cp" label="Codigo Postal" ></el-table-column>
                        <el-table-column property="provincia" label="Provincia"  ></el-table-column>
                        <el-table-column property="municipio" label="Municipio" ></el-table-column>
                        
                        <el-table-column label="Ubicacion" >
                            <template slot-scope="scope">
                                <a :href="scope.row.location" target="_blank">{{ scope.row.location }}</a>
                            </template>
                        </el-table-column>
                        </el-table>

                    </div> 

                    <div class="tables-container" v-else> <!-- de hideClientData-->
                        <div class="table-wrapper">
                            <h4>Datos del cliente</h4>
                        <el-table 
                            :data="userData"            
                            stripe
                            border                        
                        >
                        <el-table-column property="item" label="" width="165">
                            <template slot-scope="scope">
                                <span class="item-bold">{{ scope.row.item }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column property="valor" label="" width="350">
                            <template slot-scope="scope">
                                <span v-if="isItemTotalAsegurado(scope.row.item)" class="valor-italic">
                                    <span  v-if="segForm.moneda == 'Pesos'">$ </span> 
                                    <span  v-else-if="segForm.moneda == 'Dolares'">U$S </span>                                    
                                    {{ formatNumber(scope.row.valor) }}
                                </span>
                                <span v-else class="valor-italic">{{ scope.row.valor }}</span>
                            </template>
                        </el-table-column>                    
                        </el-table>

                        </div>                        
                        <!--<hr style="width: 100%;"> -->
                        <div class="table-wrapper-silos">
                            <h4>Detalle de silos</h4>
                        <el-table 
                            :data="siloData"            
                            stripe
                            border  
                            style="min-width: fit-content; table-layout: auto;"             
                        >                  
                            <el-table-column property="establecimiento" label="Establecimiento" :min-width="50" ></el-table-column>
                            <el-table-column property="silo" label="Silo" :min-width="40" ></el-table-column>
                            <el-table-column property="almac" label="Grano" :min-width="34" ></el-table-column>
                            <el-table-column property="tons" label="Toneladas [tn]" :min-width="40"></el-table-column>
                            <el-table-column property="moisture" label="Humedad [%]" :min-width="40" ></el-table-column>                                        
                            <el-table-column property="insuredAmount" :min-width="50" label="Suma A Asegurar" >
                                <template slot-scope="scope">
                                    {{ formatNumberTable(scope.row.insuredAmount) }}
                                </template>
                            </el-table-column>
                            <!--<el-table-column property="moneda" label="Moneda" ></el-table-column> -->
                        </el-table>

                        </div>

                    </div>
                </div>                                    

                <!-- </div> -->
                <!--<el-loading :loading="isLoading" fullscreen lock text="Enviando correo..." v-if="isLoading"></el-loading> -->
        </el-dialog>

    </div>
</template>

<script>

    
    import find from "../utils/finder.js";
    import api from "../utils/api/api.js"

    import wCard from "../components/common/wCard";
import { add } from "lodash";
    export default {
        name: "Establishments",
        //components: {AddEstablishmentDialog, topbar, accordeon, navMenu},
        components: {
            "w-card": wCard
        },
        data() {
            return {
                addEstablishmentFormVisible: false,
                loading: false,
                timerId: undefined,
                syncEnable: undefined,
                formTitle: "Cotiza Tu Seguro",
                goMessage: "Avanzar con la Propuesta",
                cancelMessage: "Cancelar",
                activeName: '0',
                checkedItems: [],
                silosSelected :[],
                sumarized: [],
                valor: 3923,
                statTitle: "Toneladas Totales",
                userData: [],
                siloData: [],
                isFullscreen: true,
                isLoading: false,
                elementUIStyles: `
                     <link rel="stylesheet" href="https://unpkg.com/element-ui/lib/theme-chalk/index.css">
                    `,
                mailStyles: `.el-dialog__body {
                    max-height: 100%; 
                        overflow: auto;
                        }
                        .dialog-content-wrapper {
                            display: flex;
                            flex-direction: column;
                            height: 100%;
                        }
                    .dialog-content {
                      flex: 1;
                      overflow: auto;
                    }

                    .dialog-footer {
                      position: sticky;
                      bottom: 0;
                      background: #fff;
                      padding: 10px 0;
                      text-align: right;
                      border-top: 1px solid #ebeef5;
                    }
                    .el-dialog {
                        width: 1100px;
                        height: auto;
                    }
                    .item-bold {
                        font-weight: bold;
                        color: blue
                    }
                    .valor-italic {
                        font-style: italic;
                    }

                    .estado-ok {
                        background-color: green;
                        color: white;
                        padding: 5px;
                        border-radius: 3px;
                    }
                    .estado-atencion {
                        background-color: yellow;
                        color: black;
                        padding: 5px;
                        border-radius: 3px;
                    }
                    .estado-critico {
                        background-color: red;
                        color: white;
                        padding: 5px;
                        border-radius: 3px;
                    }`,

                segForm: {
                    name: '',
                    fiscal: '',
                    codigoPostal: '',                    
                    silos: [],
                    sumaAsegurada: '',
                    plan: '',
                    vigencia: '',
                    cuotas: '',
                    moneda: '',
                    cuit: '',
                    address: ''
                },    
                dialogFormVisible: false,
                hideClientData: true,
                sumaAseguradaTotal: 0,           
                selectedSilos: [],
                silosDetails: {},
                locationData: {},
                condicionesFiscales: [
                "IVA Responsable Inscripto",
                "IVA Responsable no Inscripto",
                "IVA no Responsable",
                "IVA Sujeto Exento",
                "Consumidor Final",
                "Responsable Monotributo",
                "Sujeto no Categorizado"
                ],
                planes : [
                    "Con Robo",
                    "Sin Robo"
                ],
                vigencia :[
                    "Trimestral",
                    "Semestral"
                ],
                cuotas :[
                    "Contado",
                    "3 Cuotas",
                    "6 Cuotas"
                ],
                monedas: [
                    "Pesos",
                    "Dolares"
                ],
                rules: {
                    fiscal: [
                        { required: true, message: 'Por favor seleccion la Condicion Fiscal', trigger: 'change' }
                    ],
                    silos: [
                        { type: 'array', required: true, message: 'Por favor seleccione al menos un silo', trigger: 'change' }
                    ],
                    sumaAsegurada: [
                        { validator: this.validateSumaAsegurada, trigger: 'blur' }
                    ],
                    address: [
                        { required: true, message: 'Por favor ingrese la direccion', trigger: 'blur' }
                    ],
                    /*cuit: [
                        { 
                            required: true,
                            validator: (rule, value, callback) => {
                                if(!value) {
                                    callback(new Error('El CUIT es requerido.'));
                                }
                                const numericValue = value.replace(/[^0-9]/g, '');
                                if (numericValue.length !== 11) {
                                    callback(new Error('El CUIT debe tener exactamente 11 dígitos.'));
                                } else {
                                    callback();
                                }
                            }, 
                            trigger: 'change'
                        }
                    ]
                    */
                    //editMode: false
                }
            }
        },
        watch: {
            'segForm.silos': {
                handler(newVal) {
                this.updateSelectedSilos(newVal);
                //console.log("silos: ", this.segForm.silos);
                },
                deep: true
            },
            'silosDetails': {
                handler(newVal) {
                //console.log("silosDetails: ", this.silosDetails);
                this.sumarSumaAsegurada();
                },
                deep: true
            }
            
        },
        computed: {
            establishments: function () {
                return this.$store.state.sites.filter(est => {
                    return est.toBeDeleted === undefined || est.toBeDeleted === false;
                }).sort(function (a, b) {
                    let nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
                    if (nameA < nameB) //sort string ascending
                        return -1;
                    if (nameA > nameB)
                        return 1;
                    return 0; //default return value (no sorting)
                });

            },
            connection: function () {
                if (navigator !== undefined) {
                    return JSON.stringify(navigator.connection)
                } else {
                    return "navigator es undefined"
                }
            },
            showMenu: function () {
                return this.$store.state.showMenu;
            },
            editMode: function () {
                return this.$store.state.editMode;
            },
            isSiloSelected()
            {
                return (this.sumarized.length >0);
            },
            //De Chat GPT
            formattedSumaAsegurada: {
                get() {
                    return this.formatNumber(this.segForm.sumaAsegurada);
                },
                set(value) {
                    this.segForm.sumaAsegurada = value.replace(/[^0-9]/g, '');
                }
            },
            /*userCuitFormatted() {
                 return this.formatCuit(this.segForm.cuit);
            }
            */
            userCuitFormatted: {
             get() {
                    return this.formatCuit(this.segForm.cuit);
                },
                set(value) {
                    const numericValue = value.replace(/[^0-9]/g, ''); // Elimina todo lo que no sea números
                    this.segForm.cuit = numericValue.slice(0, 11); // Limita la entrada a 11 dígitos
                }
            }

        },
        mounted: function () 
        {
            //Cada vez que accedemos informamos el evento
           //console.log("Userid: ",this.$store.state.user.id);
           api.sendClickSeguro(this.$store.state.user.id,"ENTER_FORM_SEGURO");
                    
        },
        methods: {
            getCotizacion(indexName, index) 
            {
                return api.getCotIndex(indexName, index)
                    .then(value => {
                        let cotizacion = parseFloat(value.cot.valor);      
                        console.log("Cotizacion: ", cotizacion);  
                        return cotizacion;                                             
                    })
                    .catch(reason => {
                    console.error("Error al obtener cotizacion:", reason);                              
                    return 0;
                });
            },
            handleChangeMoneda(value)
            {
                //console.log('Moneda seleccionada:', value);
                for (let estId in this.silosDetails) {
                    for (let siloId in this.silosDetails[estId]) {
                        this.$set(this.silosDetails[estId][siloId], 'insuredAmount', 'Calculando...' );   
                    }
                }
                /*
                Obtenemos todos los indices antes de recalcular las sumas aseguradas
                */
                "MTB_ROFEX","dolar"
                Promise.all([
                    this.getCotizacion("MTB_ROFEX", "dolar"),
                    this.getCotizacion("MTB_ROFEX", "trigo"),
                    this.getCotizacion("MTB_ROFEX", "soja"),
                    this.getCotizacion("MTB_ROFEX", "maiz")
                ]).then(([dolar, trigo, soja, maiz]) => {
                    // Las tres cotizaciones se han obtenido con éxito
                    /*console.log("Dolar:", dolar);
                    console.log("Trigo:", trigo);
                    console.log("Soja:", soja);
                    console.log("Maiz:", maiz);
                    */

                // Continuar con el procesamiento aquí
                for (let estId in this.silosDetails) {
                    for (let siloId in this.silosDetails[estId]) {
                        let silo = this.silosDetails[estId][siloId];
                        //console.log("Silo: ", silo);   
                        if(silo.siloObj === undefined)
                        {
                            this.$set(this.silosDetails[estId][siloId], 'insuredAmount', '' );   
                        }
                        else
                        {
                            let tons = silo.siloObj.tons;
                            let type = silo.siloObj.type;
                            let amount = 0;
                            switch(type)
                            {
                                case "trigo":
                                    amount = tons * trigo;
                                break;
                                
                                case "soja":
                                    amount = tons * soja ;
                                break;
                                
                                case "maiz":
                                    amount = tons * maiz ;
                                break;

                                default:
                                    amount = 0;
                            
                            }
                            if(value == "Pesos")
                            {
                                amount = amount * dolar;
                            }
                            if(amount == 0)
                            {
                                this.$set(this.silosDetails[estId][siloId], 'insuredAmount', '' );   
                            }
                            else
                            {
                                let amountTxt = this.formatNumber(Math.round(amount));                                 
                                this.$set(this.silosDetails[estId][siloId], 'insuredAmount', amountTxt );
                            }    

                        }
                        
                    }
                }
                

                    
                }).catch(error => {
                    console.error("Error al obtener una o más cotizaciones:", error);

                    for (let estId in this.silosDetails) {
                        for (let siloId in this.silosDetails[estId]) {
                            this.$set(this.silosDetails[estId][siloId], 'insuredAmount', '' );   
                        }
                    }
                    this.$message({
                            message: 'ERROR al obtener las cotizaciones',
                            type: 'error',
                            duration: 3000
                        }); 

                   
                });

            },
            isItemTotalAsegurado(item)
            {
                return item == "Total a cotizar";
            },
            openDialog: function () {
                this.addEstablishmentFormVisible = true;
            },
            getEstadoText(conservation) {
                switch (conservation) {
                    case 1:
                        return 'OK';
                    case 2:
                        return 'Atencion';
                    case 3:
                        return 'Crítico';
                    default:
                        return '';
                }
            },
            getEstadoClass(conservation) {
                switch (conservation) {
                    case 1:
                    return 'estado-ok';
                    case 2:
                    return 'estado-atencion';
                    case 3:
                    return 'estado-critico';
                    default:
                        return '';
                }
            },
            sendConfirm()
            {

                this.isLoading = true;
                const loading = this.$loading({
                    lock: true,
                    text: 'Enviando solicitud de cotizacion...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                api.sendClickSeguro(this.$store.state.user.id,"ENVIO_INFORMACION_COTIZACION_SEGURO");

                this.hideClientData = false; // Mostrar todo el contenido antes de capturar el HTML                
                this.$nextTick(() => {
                    
                    /*const dialogContent = this.$refs.dialogContent.innerHTML;
                    const htmlContent = `
                    <html>
                        <head>
                            ${this.elementUIStyles}
                            <style>${this.mailStyles}</style>
                        </head>
                        <body>${dialogContent}</body>
                    </html>
                    `;

                    */
                    const userDataTable = this.generateUserDataTable();
                    const siloDataTable = this.generateSiloDataTable();

                    const htmlContent = `
                    <html>
                      <head>
                          <style>
                            .item-bold { font-weight: bold; }
                            .valor-italic { font-style: italic; }
                            .estado-ok { background-color: green; color: white; padding: 5px; border-radius: 3px; }
                            .estado-atencion { background-color: yellow; color: black; padding: 5px; border-radius: 3px; }
                            .estado-critico { background-color: red; color: white; padding: 5px; border-radius: 3px; }
                            .title {color: blue; font-weight: bold; }
                            table { width: 100%; border-collapse: collapse; }
                            th, td { border: 1px solid #ddd; padding: 8px; }
                            th { background-color: #f2f2f2; }
                        </style>
                    </head>
                    <body>
                        <h2 style="text-align: center;"> Pedido de cotizacion desde la plataforma de Wiagro</h2>
                        ${userDataTable}
                        <br>
                        <hr style="width: 100%;">
                        <br>
                        ${siloDataTable}
                       
                        <p><br>-<br></p>
				        <img width=190 height=70 src=\"cid:logoimg\" alt=WIAGRO />
                    </body>
                    </html>
                    `;                    

                    //console.log("Dialog Content: ", htmlContent);
                    const emailData = {
                        emaildata: htmlContent,
                        userData: this.userData,
                        siloData: this.siloData
                    };
                    //console.log("Email Data: ", emailData);
                    
                    api.sendDataFormSeguro(emailData).then(value => {
                        this.$message({
                            message: 'Su solicitud de cotización fue enviada. Nos pondremos en contacto a la brevedad',
                            type: 'success',
                            duration: 8000
                        });                        
                        this.$router.push("/");

                    }).catch(reason => {
                        console.error("Error al enviar el la solicitud de cotizacion", reason);                        
                        this.$message({
                            message: 'Error al enviar el la solicitud de cotizacion. Por favor intente nuevamente. Si el problema persiste, contacte al soporte de Wiagro.',
                            type: 'error',
                            duration: 5000
                        });
                       
                    }).finally(() => {
                        this.isLoading = false;
                        loading.close();
                        this.dialogFormVisible = false;
                    });

                    this.dialogFormVisible=false;
                   
                });
            },
            sendCancel()
            {
                this.$message({
                    message: 'Envio cancelado',
                    type: 'warning'
                });
                this.dialogFormVisible=false;
            },
            toggleFullscreen() {
                this.isFullscreen = !this.isFullscreen;
            },
            checkSelectedMoneda()
            {
                switch(this.segForm.moneda)
                {
                    case "Pesos":
                        return true;
                    case "Dolares":
                        return true;
                    default:
                        return false;
                }
                
            },
            sumaAseguradaPlaceholder()
            {
                switch(this.segForm.moneda)
                {
                    case "Pesos":
                        //return "Valor maximo $2740.000.000";                        
                    case "Dolares":
                        //return "Valor maximo U$S 27.400.000";
                    return "Ingrese Valor"
                    default:
                        return "Seleccione Moneda";
                }
            },
            sumarSumaAsegurada()
            {
                let suma = 0;
                for (let estId in this.silosDetails) {
                    for (let siloId in this.silosDetails[estId]) {
                        suma += this.stringToInteger(this.silosDetails[estId][siloId].insuredAmount);
                    }
                }
                this.sumaAseguradaTotal = suma;
            },
            onlyNumberInput(event) {
                //console.log("Event: ",event.keyCode)
                const keyCode = event.keyCode ? event.keyCode : event.which;
                if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
                    event.preventDefault();
                }
            },
            validateMaxValue(event) {
                const value = event.target.value;
                //console.log("Value: ", value);
                if (isNaN(value)) {
                    this.$message.error('La suma asegurada debe ser un número');
                }
                if (value && parseFloat(value) > 5740000000) {
                    this.segForm.sumaAsegurada = value.substring(0, value.length - 1);
                    this.$message.error('El valor no puede exceder $2.740.000.000');
                }
            },
            // De Chat GPT
            handleInput(event) {
                //console.log("Event en handleinput: ",event);
                let value = event.target.value.replace(/[^0-9]/g, '');
                this.segForm.sumaAsegurada = value;
                if (value && parseFloat(value) > 2740000000) {
                    this.segForm.sumaAsegurada = value.substring(0, value.length - 1);
                    value = this.segForm.sumaAsegurada;
                    this.$message.error('El valor no puede exceder $2.740.000.000');
                }
                this.$nextTick(() => {
                    event.target.value = this.formatNumber(value);
                 });
            },
            formatNumber(value) {
                console.log("Value: ", value);
                if (!value) return '';
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            },
            validateSumaAsegurada(rule, value, callback) {
                if (!value) {
                    return callback(new Error('La suma asegurada es requerida'));
                }
                if (isNaN(value)) {
                    return callback(new Error('La suma asegurada debe ser un número'));
                }
                const numberValue = parseFloat(value);
                if (numberValue > 2740000000) {
                    return callback(new Error('El valor no puede exceder $2.740.000.000'));
                }
                callback();
            },
            /// Fin Chat GPT
            setTitle: function () {
                if(this.$store.state.editMode)
                {
                    //return "Modo Edicion ";
                    return this.$t('ESTAB.EDIT_MODE');
                }
                else 
                {
                    return this.$t('ESTAB.VIEW_MODE');
                    
                }
            },
            cancel()
            {
                this.$confirm('¿Desea cancelar, perdiendo los datos?', 'Atención', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                        /*this.$message({
                        type: 'success',
                        message: 'Delete completed'
                    });
                    */
                    this.$router.push("/");
                   this.cleanSelection();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Cancelado'
                    });
                });                
            },
            handleCheckedChange(value) {
                //console.log("Value: ", value);

                /*const [estId, siloId] = value[0].split('_');
                console.log("EstId: ", estId);
                console.log("SiloId: ", siloId);

                let establishment = find.byId(this.establishments,estId );
                let silo = find.byId(establishment.silos, siloId);
                */
                this.silosSelected = value;
                

                //console.log("Valor de check:", this.silosSelected);
                this.sumarized = this.sumarizarPorGrano(value);
                //console.log("Sumarizado: ",this.sumarized);
            },
            getSiloLabel(estId, siloId) {
                return `${estId}_${siloId}`;
            },
            isSelected(estId, siloId) {
                return this.segForm.silos.includes(this.getSiloLabel(estId, siloId));
            },
            updateSelectedSilos(newVal) {
                //console.log("NewVal: ", newVal);
                // Remover detalles de silos deseleccionados
                for (let estId in this.silosDetails) {
                    for (let siloId in this.silosDetails[estId]) {
                        if (!newVal.includes(this.getSiloLabel(estId, siloId))) {
                            this.$delete(this.silosDetails[estId], siloId);
                        }
                    }
                    if (Object.keys(this.silosDetails[estId]).length === 0) {
                      this.$delete(this.silosDetails, estId);
                    }
                }

                // Añadir detalles de silos seleccionados
                newVal.forEach(label => {
                    const [estId, siloId] = label.split('_');
                    //console.log("EstId: ", estId);
                    //console.log("SiloId: ", siloId);
                    if (!this.silosDetails[estId]) {
                        this.$set(this.silosDetails, estId, {});
                    }
                    if (!this.silosDetails[estId][siloId]) 
                    {
                        //buscamos el objeto silo del establecimiento
                        let establishment = find.byId(this.establishments,estId );
                        let silo = find.byId(establishment.silos, siloId);                       
                        this.$set(this.silosDetails[estId], siloId, { postalCode: 'Buscando...', insuredAmount: 'Calculando...',siloObj: silo, locationData: {}, locationSearhing: true, amountSearching: true });  

                        /*let locationSilo =  this.getSiloLocation(silo);
                        silo.location = locationSilo;
                        if(locationSilo != null)
                        {
                            if(locationSilo.address != undefined)
                            {
                                if(locationSilo.address.postcode != undefined)
                                {
                                    this.silosDetails[estId][siloId].postalCode = locationSilo.address.postcode;
                                }
                            }

                        }
                        */

                        // Obtener la ubicación del silo

                        this.getSiloLocation(silo).then(locationSilo => 
                        {
                            this.$set(this.silosDetails[estId][siloId], 'locationSearhing', false);

                            if (locationSilo != null && locationSilo.address && locationSilo.address.postcode) 
                            {
                                this.$set(this.silosDetails[estId][siloId], 'postalCode', locationSilo.address.postcode);                              
                                this.$set(this.silosDetails[estId][siloId],'locationData', locationSilo);
                            }   
                            else 
                            {
                                this.$set(this.silosDetails[estId][siloId], 'postalCode', '');          
                            }  
                        });

                        //Obtener la suma asegurada en funcion a las toneladas del silo
                        let dolar = 0;
                        let error = false;
                        let amount = 0;
                        api.getCotIndex("MTB_ROFEX","dolar").then(value => {
                            dolar = parseFloat(value.cot.valor);      
                            console.log("Cotizacion del dolar: ", dolar);                                                  
                        }).catch(reason => {
                            console.error("Error al obtener cotizacion del dolar", reason);  
                            this.$set(this.silosDetails[estId][siloId], 'insuredAmount', '');                                                  
                            error = true;
                       
                        }).finally(() => {
                            if(!error)
                            {
                                api.getCotIndex("MTB_ROFEX",silo.type).then(value => {
                                let cotizacion = parseFloat(value.cot.valor);
                                let tons = parseFloat(silo.tons);    
                                

                                switch(this.segForm.moneda)
                                {
                                    case "Pesos":
                                        amount = tons * cotizacion * dolar;
                                    break;
                                
                                    case "Dolares":
                                        amount = tons * cotizacion;
                                    break;
                                
                                    default:
                                
                                } 
                                
                                let amountTxt = this.formatNumber(Math.round(amount));
                                 //amount.toFixed(0);

                                this.$set(this.silosDetails[estId][siloId], 'insuredAmount', amountTxt );

                                }).catch(reason => {
                                    console.error("Error al obtener cotizacion", reason);  
                                    this.$set(this.silosDetails[estId][siloId], 'insuredAmount', '');                      
                       
                                }).finally(() => {
                                    this.$set(this.silosDetails[estId][siloId], 'amountSearching', false);
                                });

                            }      
                            else 
                            {
                                this.$set(this.silosDetails[estId][siloId], 'amountSearching', false);
                            }                      
                        });


 
                    }
                });

                //console.log("Silos Details: ", this.silosDetails);
                //Imprimo el objeto en formato JSON
                //console.log("Silos Details JSON: ", JSON.stringify(this.silosDetails));

                //Iterate all this.silosDetails and get the sumarized data
                let silos = [];
                for (let estId in this.silosDetails) {
                    for (let siloId in this.silosDetails[estId]) {
                        silos.push(this.silosDetails[estId][siloId].siloObj);
                    }
                }
                this.sumarized = this.sumarizarPorGrano(silos);
            },
            handleCheckboxChange(estId,siloId, event) {
                //console.log("EstId: ", estId);
                //console.log("SiloId: ", siloId);
                //console.log("Event: ", event);
                let obj = {
                    establishmentId: estId,
                    siloId: siloId
                }
                if (event) {
                    this.selectedSilos.push(obj);
                    this.$set(this.silosDetails,estId, siloId, { postalCode: '', insuredAmount: '' });
                } 
                else 
                {
                    const index = this.selectedSilos.indexOf(obj);
                    if (index !== -1) {
                        this.selectedSilos.splice(index, 1);
                    }
                    this.$delete(this.silosDetails, estId, siloId);
                }
                //console.log("Selected Silos: ", this.selectedSilos);
            },
            cleanSelection()
            {
                 this.segForm.silos = [];
                 this.silosSelected = [];
                 this.silosDetails = {};
                 this.sumarized = [];
            },
            isObjectEmpty(obj) {
                return Object.keys(obj).length === 0;
            },
            sendRequest()
            {                
                
                /*console.log("Cantidad de silos seleccionados: ",this.silosSelected.length);
                if(this.silosSelected.length == 0)
                {
                    alert("Debe seleccionar almenos un silo")
                }
                */

               //console.log("Formulario: ", this.segForm);
               //console.log("Silos Details: ", this.silosDetails);   

                //Chequeamos si silosSelected tiene elementos
                


                //Chequeamos si el CUIT es correcto
                /*if(this.segForm.cuit == "")
                {
                    alert("Debe ingresar el CUIT");
                    return;
                }
                */

                //Chequeamos si la condicion fiscal es correcta
                if(this.segForm.fiscal == "")
                {
                    alert("Debe seleccionar la condición fiscal");
                    return;
                }
                //Chequeamos la direccion 
                if(this.segForm.address == "")
                {
                    alert("Debe ingresar la dirección");
                    return;
                }
                //Chequeamos si la moneda es correcta
                if(this.segForm.moneda == "")
                {
                    alert("Debe seleccionar la moneda");
                    return;
                }
                //Chequeamos si el plan es correcto
                if(this.segForm.plan == "")
                {
                    alert("Debe seleccionar el plan");
                    return;
                }
                //Chequeamos si las cuotas son correctas
                if(this.segForm.cuotas == "")
                {
                    alert("Debe seleccionar las cuotas");
                    return;
                }
                if(!this.isObjectEmpty(this.silosDetails))
                {
                    //Chequeamos si todos los silos tienen CP
                    let silos = [];
                    for (let estId in this.silosDetails) {
                        for (let siloId in this.silosDetails[estId]) {
                            if(this.silosDetails[estId][siloId].postalCode == "")
                            {
                                alert("Debe ingresar el Código Postal de todos los silos seleccionados");
                                return;
                            }
                            silos.push(this.silosDetails[estId][siloId].siloObj);
                        }
                    }
                    //Chequeamos si todos los silos tienen suma asegurada
                    for (let estId in this.silosDetails) {
                        for (let siloId in this.silosDetails[estId]) {
                            if(this.silosDetails[estId][siloId].insuredAmount == "")
                            {
                                alert("Debe ingresar la suma asegurada de todos los silos seleccionados");
                                return;
                            }
                        }
                    }
                    //Chequeamos si la suma asegurada total es mayor a 0
                    if(this.sumaAseguradaTotal == 0)
                    {
                        alert("La suma asegurada total debe ser mayor a 0");
                        return;
                    }
                    //Chequeamos si la suma asegurada total es menor a 2740000000
                    /*if(this.sumaAseguradaTotal > 2740000000)
                    {
                        alert("La suma asegurada total no puede superar los 2.740.000.000");
                        return;
                    }
                    */

                }
                else
                {
                    alert("Debe seleccionar almenos un silo");
                    return;
                }
                
                api.sendClickSeguro(this.$store.state.user.id,"AVANZA_PROPUESTA_SEGURO");

                this.loadUserData();
                this.loadSiloDetailData();
                this.dialogFormVisible=true;
                this.hideClientData= true; //Ocultamos algunos datos del cliente
                /*this.$message({
                    message: 'Pedido de cotizacion enviado',
                    type: 'success'
                });
                */

            },
            showSiloInfo(silo)
            {
                return silo.name + " (" + silo.type + ")" +  " - " + silo.tons + " Ton";
            },
            estabTitle(name)
            {
                //let ret;
                //ret = "<span class='estabtitle'>" + name + "</span>";
                return name;

            },
            stringToInteger(str) {
                if(str === undefined || str === null  || str === "") {
                    return 0;
                }
                // Eliminar los puntos de la cadena
                const numberStr = str.replace(/\./g, '');
                // Convertir la cadena resultante a un número entero
                const number = parseInt(numberStr, 10);
                //check if NaN
                if (isNaN(number)) {
                    return 0;
                }
                return number;
            },
            formatNumberTable(str)
            {
                let number = this.stringToInteger(str);
                let moneda;
                if(this.segForm.moneda == 'Pesos')
                {
                    moneda = '$ ' ; 
                }
                else
                {
                    moneda = 'U$S '; 
                }
                return ( moneda + this.formatNumber(number));
            },
            sumarizarPorGrano(data) //De Chat GPT 
            {
                //console.log("Data en Sumarizar: ", data);
                // Objeto para almacenar las sumas por tipo de grano y la cantidad de objetos por tipo de grano
                const sumasPorGrano = {};

                // Recorrer el array original
                data.forEach(item => {
                    // Obtener el tipo de grano y el peso
                    const { type, tons } = item;
                    // Sumarizar por tipo de grano
                    if (sumasPorGrano.hasOwnProperty(type)) {
                        sumasPorGrano[type].tons += parseInt(tons);
                        sumasPorGrano[type].count++;
                    } 
                    else 
                    {
                        sumasPorGrano[type] = { tons: parseInt(tons), count: 1 };
                    }
                });

                // Convertir el objeto de sumas a un array de objetos
                const sumasArray = Object.keys(sumasPorGrano).map(type => ({
                    type,
                    tons: sumasPorGrano[type].tons,
                    count: sumasPorGrano[type].count
                }));

                return sumasArray;
            },
            getGrainName(grain)
            {
                let key;
                let gr;
                let name;

                gr = grain;
                key = 'GRAIN.' + gr.toUpperCase();
      
                name = this.$t(key);

                return name;
      
            },   
            /*getLocationData(lat,lon)
            {
                // https://nominatim.openstreetmap.org/reverse?lat=-33.866242&lon=-60.727848&format=json
                let url = "https://nominatim.openstreetmap.org/reverse?lat=" + lat + "&lon=" + lon + "&format=json";
                fetch(url)
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    this.locationData = data;
                    return data;
                })                
            },
            */
            async  getLocationData(lat, lon) {
                let url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`;
                
                try {
                    let response = await fetch(url);
                    let data = await response.json();
                    //console.log(data);
                    this.locationData = data;
                    return data;
                } catch (error) {
                    console.error('Error fetching location data:', error);
                    return null;
                }
            },
            async getSiloLocation(silo)
            {
                //console.log("Silo en getLocation: ", silo);
                if(silo.position.lat && silo.position.long)
                {
                    let locationData =  await this.getLocationData(silo.position.lat, silo.position.long);                                
                    //console.log("Data: ", locationData);
                    return locationData;                                
                }
            },
            handleInputCuit(event) {
                 //const value = event.target.value.replace(/[^0-9]/g, ''); // Elimina todo lo que no sea números
                 //this.segForm.cuit = value.slice(0, 11); // Limita la entrada a 11 dígitos
                 this.userCuitFormatted = event.target.value;
            },
            formatCuit(value) {
                if (value.length <= 2) {
                return value;
                } else if (value.length <= 10) {
                    return `${value.slice(0, 2)}-${value.slice(2)}`;
                    } else {
                        return `${value.slice(0, 2)}-${value.slice(2, 10)}-${value.slice(10)}`;
                    }
            },
            confirmBorrarSeleccion()
            {
                this.$confirm('¿Desea borrar la selección de silos?', 'Atención', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                        /*this.$message({
                        type: 'success',
                        message: 'Delete completed'
                    });
                    */
                   this.cleanSelection();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Cancelado'
                    });          
                });
            },
            loadUserData()
            {
                let user = this.$store.state.user;
                let item = {
                    item: "",
                    valor: ""
                }

                this.userData = []; // Asegúrate de inicializar o limpiar el array

                // Crea y empuja un nuevo objeto item en cada iteración
                this.userData.push({ item: "Nombre", valor: user.name });
                //this.userData.push({ item: "CUIT", valor: this.segForm.cuit });
                this.userData.push({ item: "Telefono", valor: user.tel });
                this.userData.push({ item: "e-mail", valor: user.mail });
                this.userData.push({ item: "Direccion", valor: this.segForm.address });
                this.userData.push({ item: "Condicion fiscal", valor: this.segForm.fiscal });
                this.userData.push({ item: "Plan", valor: this.segForm.plan });
                //this.userData.push({ item: "Vigencia", valor: this.segForm.vigencia });
                this.userData.push({ item: "Cantidad de cuotas", valor: this.segForm.cuotas });
                this.userData.push({ item: "Moneda", valor: this.segForm.moneda });
                this.userData.push({ item: "Total a cotizar", valor: this.sumaAseguradaTotal });

               // console.log("UserData: ", this.userData);

            },  
            getEstabName(estId)
            {
                let establishment = find.byId(this.establishments,estId );
                return establishment.name;
            },
            loadSiloDetailData()
            {
                /*
                Establecimiento, Campo Grande
                Silo, Silo 1
                Almacenamiento, Soja
                Toneladas, 145
                Humedad inicial, 12%
                Estado de conservación, Bueno
                Suma Asegurada, 12468
                Moneda, USD
                CP, 2723
                Provincia, Santa Fe
                Municipio, Juncal
                Ubicación, https://www.google.com/maps?q=-33.7408035,-61.0629269
                */
                
                this.siloData = [];
                for (let estId in this.silosDetails) {
                      let estabName = this.getEstabName(estId);
                      for (let siloId in this.silosDetails[estId]) {
                        let silo = this.silosDetails[estId][siloId];
                        let provincia = "";
                        if(silo.locationData.address != undefined)
                        {
                            if(silo.locationData.address.state != undefined)
                            {
                                provincia = silo.locationData.address.state;
                            }
                        }
                        let municipio = "";
                        if(silo.locationData.address != undefined)
                        {
                            if(silo.locationData.address.state_district != undefined)
                            {
                                municipio = silo.locationData.address.state_district;
                            }
                        }
                        this.siloData.push({ 
                            establecimiento: estabName,
                            silo: silo.siloObj.nombre,
                            almac: this.getGrainName(silo.siloObj.type),
                            tons: silo.siloObj.tons,
                            moisture: silo.siloObj.initmoisture,
                            conservation: silo.siloObj.status,
                            insuredAmount: silo.insuredAmount,  
                            moneda: this.segForm.moneda,     
                            cp: silo.postalCode,
                            provincia: provincia,
                            municipio: municipio,  
                            location: "https://www.google.com/maps?q=" + silo.siloObj.position.lat + "," + silo.siloObj.position.long             
                         });
                      
                      }
                }

            },
            getTooltipText()
            {
                switch(this.segForm.moneda)
                {
                    case "Pesos":
                        return "Ingrese el monto total en pesos multiplicando la cantidad de toneladas por el valor actual de la tonelada del activo almacenado.";
                    case "Dolares":
                        return "Ingrese el monto total en dolares multiplicando la cantidad de toneladas por el valor actual de la tonelada del activo almacenado.";
                    default:
                        return "Seleccione Moneda";
                }
                
            },
            generateUserDataTable() {
                let table = '<h3 class="title">Datos del cliente</h3>';
                table += '<table>';
                //table += '<tr><th>Item</th><th>Valor</th></tr>';
                this.userData.forEach(row => {
                    /*<span v-if="isItemTotalAsegurado(scope.row.item)" class="valor-italic">
                                    {{ formatNumber(scope.row.valor) }}
                                    <span  v-if="segForm.moneda == 'Pesos'"> $</span> 
                                    <span  v-else-if="segForm.moneda == 'Dolares'"> U$S</span>

                                </span>
                    */
                   if(this.isItemTotalAsegurado(row.item))
                   {

                        table += `<tr><td class="item-bold" >${row.item}</td><td class="valor-italic" > `;
                        if(this.segForm.moneda == 'Pesos')
                        {
                            table += `<span>$ </span>`; 
                        }
                        else
                        {
                            table += `<span>U$S </span>`; 
                        }   
                        table += `${this.formatNumber(row.valor)} `;
                   }
                   else
                   {
                        table += `<tr><td class="item-bold" >${row.item}</td><td class="valor-italic">${row.valor}</td></tr>`;
                   }
                    //table += `<tr><td class="item-bold">${row.item}</td><td class="valor-italic">${row.valor}</td></tr>`;
                });
                table += '</table>';
                return table;
            },
            generateSiloDataTable() {
                let table = '<h3 class="title">Datos de los silos</h3>';
                table += '<table>';
                //table += '<tr><th>Establecimiento</th><th>Silo</th><th>Almacenamiento</th><th>Toneladas</th><th>Humedad</th><th>Estado</th><th>Suma A Asegurar</th><th>Moneda</th><th>Código Postal</th><th>Provincia</th><th>Municipio</th><th>Ubicación</th></tr>';
                //<td>${row.moneda}</td>
                table += '<tr><th>Establecimiento</th><th>Silo</th><th>Grano</th><th>Toneladas [tn]</th><th>Humedad [%]</th><th>Estado</th><th>Suma A Asegurar</th><th>Código Postal</th><th>Provincia</th><th>Municipio</th><th>Ubicación</th></tr>';
                this.siloData.forEach(row => {
                table += `
                <tr>
                    <td>${row.establecimiento}</td>
                    <td>${row.silo}</td>
                    <td>${row.almac}</td>
                    <td>${row.tons}</td>
                    <td>${row.moisture}</td>
                    <td><span class="${this.getEstadoClass(row.conservation)}">${this.getEstadoText(row.conservation)}</span></td>
                    <td>${this.formatNumberTable(row.insuredAmount)}</td>                    
                    <td>${row.cp}</td>
                    <td>${row.provincia}</td>
                    <td>${row.municipio}</td>
                    <td><a href="${row.location}" target="_blank">${row.location}</a></td>
                </tr>
                `;

                });
                table += '</table>';
                return table;
            }

        },
        beforeDestroy() {
        }
    }
</script>

<style  scoped lang="scss">

    .image-container {
    margin-top: 10px;
    text-align: center; /* Asegura que la imagen esté centrada incluso si no tiene ancho completo */
}

.centered-image {
    /*max-width: 25%;*/
    max-width: 250px;
    display: block;
    margin: 0 auto;
}
    .acction-button-container {
        margin-top: 3em;
        align-items: center;
    }

    .message-box {
        font-family: Roboto, sans-serif;
        font-weight: normal;
        width: 70%;

    }

    .logo-title-container
    {
            height: 60px;
            margin: 20px;
            display: flex;
            align-items: normal;

    }

    .logo-container {
            height: 10%;
            margin-right: 1em;
            display: flex;
            align-items: center;

            &__logo {
                height: 70%;
            }
    }
        

    $brand-success: #5cb85c;
    $brand-error: #D06079;
    $brand-warning: #e6a23c;
    $loader-size: 2.5em;

    .circle-loader {
        border: 2px solid rgba(0, 0, 0, 0.2);
        border-left-color: $brand-success;
        animation: loader-spin 1.2s infinite linear;
        position: relative;
        display: inline-block;
        vertical-align: top;
        border-radius: 50%;
        width: $loader-size;
        height: $loader-size;
    }

    .el-loading-spinner {
        top: 50vh;

    }

    @keyframes loader-spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    .estabitem {
        font-size: larger;
        font-weight: bold;
    }
    .estabtitle {
 
	/*font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    */
	/*font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #212529;
    text-align: left;*/
        font-size: larger;
        font-weight: bold;
        color: blue
    }

    .loading-text {
        top: -2em;
        bottom: -100vh;

        .el-loading-spinner .el-loading-text {
            color: $brand-success;
            font-family: Roboto, sans-serif;
            margin-top: 1em;
            font-size: 1em;
        }
    }

    .el-dialog__body {
        padding: 30px 20px !important;

    }
    .accordionComponent {
 
            /*font-family: Roboto, serif;*/
            font-weight: normal;
            font-size: 4.90em;
            margin-left: 3px;
            width: 100%;
            color: #FFFFFF;
            overflow: hidden;
        
    }
    .content {
        text-align: left;
        margin: 3px;
    }
    .statscontent {
        width: 100%; /* Ajusta el ancho según sea necesario */
        margin: 0 auto; /* Esto centra el contenedor horizontalmente */
        max-width: 1200px; /* Define un ancho máximo para el contenedor */
    }
    .rowcontent {
        display: flex;
        justify-content: center; /* Centra horizontalmente los elementos */

    }
    .checkbox-item {
  display: block;
  margin-bottom: 10px;
}

.accordionComponent .checkbox-item {
    margin-bottom: 10px;
}

.accordionComponent .checkbox-item div {
    margin-top: 5px;
}

.accordionComponent label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
}
.demo-input-label {
    display: inline-block;
    width: 149px;
    visibility: visible;
  }
  .moneda {
    font-weight: bold;
    color: brown;
    font-size: larger;
  }
  .monto {
    font-weight: bold;
    color: blue;
    font-size: larger;
  }
  .stats{
    text-align: center;
    align-items: center;
  }
  .el-dialog__body {
  max-height: 100%; /* Ajusta la altura según sea necesario */
  overflow: auto;
}
.dialog-content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.dialog-content {
  flex: 1;
  overflow: auto;
}

.dialog-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 10px 0;
  text-align: right;
  border-top: 1px solid #ebeef5;
}
.el-dialog {
    width: 1100px;
    height: auto;
}
.item-bold {
    font-weight: bold;
    color: blue
}
.valor-italic {
    font-style: italic;
}

.estado-ok {
    background-color: green;
    color: white;
    padding: 5px;
    border-radius: 3px;
}
.estado-atencion {
    background-color: yellow;
    color: black;
    padding: 5px;
    border-radius: 3px;
}
.estado-critico {
    background-color: red;
    color: white;
    padding: 5px;
    border-radius: 3px;
}

.bold-label .el-form-item__label {
    font-weight: bold;
}

/*
.tables-container {
  display: flex;
  overflow-x: auto;
  gap: 20px;
}

.table-wrapper {
  min-width: fit-content;
  max-height: 100vh;
  overflow: auto;
}
*/

.tables-container {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  width: 100%;
}

.table-wrapper {
  flex: 1;
  overflow: auto;
}


.table-wrapper-silos {
    flex: 2;
  overflow: auto; 
}

/* Media query para pantallas pequeñas */
@media (max-width: 768px) {
  .tables-container {
    flex-direction: column;
  }
}
</style>